import React, {Component} from "react";
import { RadialMenu } from "../external/RadialMenu";

interface IRadialMenuContainerProps {
    onClick(item: any): void
    onClose(): void;
    items: IRadialOption[];
}

interface IRadialMenuContainerState {
}

export interface IRadialOption
{
    id: string;
    title: string;
    items?: IRadialOption[];
}


export default class RadialMenuContainer extends Component<IRadialMenuContainerProps, IRadialMenuContainerState> {

    containerDivRef: any;
    private menu?: RadialMenu;

    constructor(props: Readonly<IRadialMenuContainerProps>) {
        super(props);

        this.containerDivRef = React.createRef();

        this.state = {
        };
    }

    public componentDidMount() {
        this.menu = new RadialMenu({
            parent      : this.containerDivRef.current,
            size        : 400,
            closeOnClick: false,
            menuItems   : this.props.items,
            onClose: this.props.onClose,
            onClick     : this.props.onClick
        });
        
        this.menu.open();
    }



    componentDidUpdate(prevProps: Readonly<IRadialMenuContainerProps>, prevState: Readonly<IRadialMenuContainerState>, snapshot?: any): void {
    }
    componentWillUnmount() {
    }

    public render() {
        return (
            <div className={"radial-menu-container"} ref={this.containerDivRef} onClick={(e) => {
                this.menu?.close()
            }}>
            </div>
        );
    }
}